<template>
  <iframe :src="$route.query.url" style="width: 100%; min-height: 100vh;" />
</template>

<script>
export default {
  name: "EmbedPage"
};
</script>
